import { Injectable, OnDestroy } from '@angular/core';
import { Logger } from 'common/utility/logger/logger';
import { Observable } from 'rxjs';
import { Battery } from 'services/battery/battery';
import { ApiController } from 'services/http/api-controller';
import { Api } from 'services/http/api-endpoints';
import { HttpService } from 'services/http/http.service';
import { Endpoint } from 'services/http/interface/endpoint';
import { Route } from 'services/http/routes';

@Injectable({
  providedIn: 'root'
})
export class BatteryStringsService implements OnDestroy {

  public getBatteries(edgeId: string): Observable<any> {
    Logger.debug("getBatteries invoked", edgeId)
    const controller: ApiController = Api.batteryString
    const action: string = Route.BatteryString.Fetch;
    const endpoint: Endpoint = Api.getEndpoint(controller, action);
    return this.httpService.request(controller, action, Api.createParameters(endpoint.route, [edgeId]))
  }
  
  public saveBattery(batteryId: string, data: Battery): Observable <any> {
    const endpoint: Endpoint = Api.getEndpoint(Api.batteryString, Route.BatteryString.Set);
    return this.httpService.request(Api.batteryString, Route.BatteryString.Set, Api.createParameters(endpoint.route, [batteryId]), data)
  }
  
  constructor(
    private httpService: HttpService
  ) { }

  ngOnDestroy(): void { }

}
